import {Redirect, Route, Switch as RouterSwitch} from 'react-router-dom';

import config from '../../../../config';

import OrganisationProjectList from '../../organisationProjectList';
import OrganisationUserList from '../../organisationUserList';
import PageNotFound from '../../pageNotFound';

import DocumentsList from '../DocumentsList';
import {useClientDetailsStore} from '../ClientDetailsStore';

function Switch() {
  const {
    dispatch,
    state: {client, interventions, users}
  } = useClientDetailsStore();

  const displayDocumentsTab = config.featureFlags.relationshipDocuments?.clientDocuments;

  return (
    <div className="mb-5">
      <RouterSwitch>
        <Redirect
          from="/client/:clientId"
          exact
          to={displayDocumentsTab ? '/client/:clientId/documents' : '/client/:clientId/users'}
        />
        {displayDocumentsTab &&
        <Route
          exact
          path="/client/:clientId/documents"
          component={DocumentsList}
        />
        }
        <Route
          exact
          path="/client/:clientId/users"
          render={() => (
            <OrganisationUserList
              organisation={client.details}
              users={users.list}
              pageSize={users.pageSize}
              totalCount={users.totalCount}
              loading={users.loading}
              error={users.error}
              onRefresh={() => dispatch({type: 'FETCH_USERS'})}
            />
          )}
        />
        <Route
          exact
          path="/client/:clientId/projects"
          render={() => (
            <OrganisationProjectList
              interventions={interventions.list}
              pageSize={interventions.pageSize}
              totalCount={interventions.totalCount}
              loading={interventions.loading}
              error={interventions.error}
              onPageChange={() => dispatch({type: 'FETCH_INTERVENTIONS'})}
            />
          )}
        />
        <Route component={PageNotFound}/>
      </RouterSwitch>
    </div>
  );
}
export default Switch;
